<template>
  <v-col
    cols="12"
  >
    <v-card>
      <v-card-title>
        Add committee members
      </v-card-title>

      <v-form
        @submit="addCommitteeMember"
      >
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="newEmail"
                label="email"
                type="email"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="2"
            >
              <v-btn
                type="submit"
              >
                Add Committee Member
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'CommitteeAdd',
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newEmail: '',
    };
  },
  methods: {
    async addCommitteeMember(form) {
      form.preventDefault();
      await this.client.addMember(this.newEmail);
      this.newEmail = '';
      this.$emit('submit');
    },
  },
};
</script>
